import { startbeitragRegistrieren, type Kernaktion, type Startlage } from "../plattform/startansicht";
import { ZIELE } from "./ziele";

/**
 * Hauptaktionen der Startansicht, die eine Ansicht der Drückjagd öffnen (oberflaeche.md §4.3; design/README §10.2):
 *
 * - Treiber: „Einweisung“ vor Beginn und danach (während „Wildsichtung“, Kontext Lage).
 * - Treiberführer: „Einweisung“ als Rückfall, sobald „am Start“ bzw. „am Sammelpunkt“ gemeldet ist und keine Zeile
 *   der Person eine andere Hauptaktion hat.
 * - Nachweisprüfer: „Kontrollliste“ in jeder Phase. Die Kernaktion Nachweiskontrolle steht sonst direkt in
 *   `navigation` „Drückjagd“ (ziele.ts `kernziele`, §3.1 V-12).
 *
 * „Hunde im Treiben“ der Hundeführer liefert der Kontext Lage, „Strecke“ der Wildversorgung der Kontext Strecke.
 */
const RANG = { Treiber: 2, Treiberführer: 3, Nachweisprüfer: 7 } as const;

function hauptaktion(begriff: string, id: string, rang: number, rueckfall = false): Kernaktion {
  const ziel = ZIELE[begriff]!;
  return { begriff, symbol: ziel.symbol, pfad: ziel.pfad(id), rang, haupt: true, nurAlsHaupt: true, ...(rueckfall ? { rueckfall } : {}) };
}

function useDrueckjagdbeitrag({ drueckjagdId: id, rollen, phase }: Startlage) {
  const kernaktionen: Kernaktion[] = [];
  if (rollen.includes("Treiber") && phase !== "während") kernaktionen.push(hauptaktion("Einweisung", id, RANG.Treiber));
  if (rollen.includes("Treiberführer") && phase !== "während") kernaktionen.push(hauptaktion("Einweisung", id, RANG.Treiberführer, true));
  if (rollen.includes("Nachweisprüfer")) kernaktionen.push(hauptaktion("Kontrollliste", id, RANG.Nachweisprüfer));
  return { kernaktionen };
}

startbeitragRegistrieren(useDrueckjagdbeitrag);
